import type { ChangePlanResult, OnboardingChecklist, TenantBanner, TenantSubscriptionOverview, TicketCreateInput, TicketDto } from '@brechoflow/contracts';
import type { Paginated } from '@brechoflow/contracts';
import { http } from '@/lib/api';

export const sqk = {
  overview: (orgId?: string) => ['subscription', orgId, 'overview'] as const,
  banner: (orgId?: string) => ['subscription', orgId, 'banner'] as const,
  features: (orgId?: string) => ['subscription', orgId, 'features'] as const,
  onboarding: (orgId?: string) => ['org', orgId, 'onboarding'] as const,
  tickets: (orgId?: string) => ['support', orgId, 'tickets'] as const,
};

export const subscriptionApi = {
  overview: () => http.get<TenantSubscriptionOverview>('/subscription'),
  banner: () => http.get<TenantBanner>('/subscription/banner'),
  features: () => http.get<{ features: Record<string, boolean>; planName: string | null }>('/subscription/features'),
  changePlan: (planId: string) => http.post<ChangePlanResult>('/subscription/change-plan', { planId }),
  cancel: () => http.post('/subscription/cancel', { immediately: false }),
  reactivate: () => http.post('/subscription/reactivate'),
  portal: () => http.get<{ url: string }>('/subscription/portal'),
};

export const onboardingApi = {
  get: () => http.get<OnboardingChecklist>('/onboarding'),
  patch: (b: { wizardCompleted?: boolean; dismissed?: boolean; skippedSteps?: string[] }) => http.patch<OnboardingChecklist>('/onboarding', b),
  loadDemo: () => http.post('/onboarding/demo-data'),
  removeDemo: () => http.delete('/onboarding/demo-data'),
};

export const supportApi = {
  list: () => http.get<Paginated<TicketDto> | TicketDto[]>('/support/tickets'),
  create: (b: TicketCreateInput) => http.post<TicketDto>('/support/tickets', b),
};
